import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { Course, CourseActivity, LibraryResponse, Product }  from '@server/other/classes';
import ApiService from '@web-client/services/ApiService';


interface LearningCoursesState {
  courses: Product[];
  error: string | null;
  isFetchingCourses: boolean;
  filter: 'all' | 'purchased' | 'subscribed';
}

// Initial state
const initialState: LearningCoursesState = {
  courses: [],
  error: null,
  isFetchingCourses: false,
  filter: 'all',
};

// Async thunk to fetch courses
export const fetchLearningCourses =
  createAsyncThunk('courses/fetchLearningCourses', async () => {
    return await ApiService.getInstance().getLibrary() as LibraryResponse;
});

// Redux slice
export const coursesSlice = createSlice({
  name: 'learningCourses',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload; // Update the filter
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLearningCourses.pending, (state) => {
        state.isFetchingCourses = true; // Set loading state
        state.error = null; // Reset error
      })
      .addCase(fetchLearningCourses.fulfilled, (state, action) => {
        if (action.payload?.productsWithActivity != null) {
          state.courses = action.payload.productsWithActivity;
        }
        state.isFetchingCourses = false; // Reset loading state
      })
      .addCase(fetchLearningCourses.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch courses';
        state.isFetchingCourses = false; // Reset loading state
      });
  },
  selectors: {
    selectCourses: (state) => state.courses,
    selectIsFetchingCourses: (state) => state.isFetchingCourses,
    selectError: (state) => state.error,
    selectFilter: (state) => state.filter,
  },
});

export const selectors = coursesSlice.selectors;



// Export actions and reducer
export const { setFilter } = coursesSlice.actions;
export default coursesSlice.reducer;
